module.exports = __webpack_public_path__ + "img/radar_blue.a8be4781.svg";